import { FoodsIcon, WhiteBox } from "@foodpilot/foods";
import { Stack, Typography, useTheme, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    questionnaireName: string;
};
export const LockedStrategy = (props: Props) => {
    const { questionnaireName } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <WhiteBox padding={theme.spacing(4)} height={"100%"}>
            <Stack gap={theme.spacing(4)}>
                <Box sx={{ color: theme.custom.grey[2000] }}>
                    <FoodsIcon size={10} icon={"lock"} />
                </Box>
                <Typography
                    variant="h3"
                    sx={{
                        color: theme.custom.grey[2000],
                    }}
                >
                    {t(
                        "strategy.locked.with_score",
                        "First complete and validate your {{questionnaireName}} questionnaire.",
                        {
                            questionnaireName,
                        },
                    )}
                </Typography>
                <Typography
                    variant="body"
                    sx={{
                        color: theme.custom.grey[2000],
                    }}
                >
                    {t(
                        "strategy.locked.description",
                        "This section will be available once you have completed and validated your firstquestionnaire.",
                    )}
                </Typography>
            </Stack>
        </WhiteBox>
    );
};
